var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 91,
    viewBox: "0 0 146 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 75,
    rx: 3,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 1,
    width: 2,
    height: 74,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 1,
    width: 21,
    height: 74,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 9,
    width: 68,
    height: 4,
    rx: 2,
    fill: "#8D4DC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 47,
    width: 68,
    height: 4,
    rx: 2,
    fill: "#E8DBF4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 58,
    width: 68,
    height: 4,
    rx: 2,
    fill: "#8D4DC9",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 69,
    width: 68,
    height: 4,
    rx: 2,
    fill: "#8D4DC9",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 18,
    width: 55,
    height: 1,
    fill: "#EC9770"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 55,
    height: 1,
    fill: "#EC9770"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 30,
    width: 55,
    height: 1,
    fill: "#EC9770"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 55,
    height: 1,
    fill: "#EC9770"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 75,
    width: 75,
    height: 2,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 41,
    width: 18,
    height: 2,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 40C42.8953 40 42 40.8953 42 42C42 43.1047 42.8953 44 44 44C45.1047 44 46 43.1047 46 42C46 40.8953 45.1047 40 44 40ZM44.8071 42.2031H44.2031V42.8071H43.7969V42.2031H43.1929V41.7969H43.7969V41.1929H44.2031V41.7969H44.8071V42.2031Z",
    fill: "#624AB6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 69.5,
    r: 21.5,
    fill: "#E9706D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.088 80.3955C128.57 80.3955 131.749 77.7881 131.749 74.1553V74.126C131.749 71.167 129.669 69.292 126.563 69.0137V68.9404C129.142 68.3984 131.017 66.6406 131.017 64.0186V63.9893C131.017 60.7227 128.263 58.4668 124.059 58.4668C119.928 58.4668 117.115 60.8252 116.793 64.3848L116.778 64.5459H119.854L119.869 64.3994C120.074 62.4072 121.715 61.1621 124.059 61.1621C126.446 61.1621 127.823 62.3633 127.823 64.4141V64.4434C127.823 66.4062 126.183 67.8271 123.766 67.8271H121.29V70.376H123.868C126.681 70.376 128.409 71.709 128.409 74.0967V74.126C128.409 76.2061 126.666 77.6562 124.088 77.6562C121.466 77.6562 119.693 76.3086 119.488 74.3896L119.474 74.2432H116.339L116.354 74.4189C116.632 77.9199 119.576 80.3955 124.088 80.3955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.2af48574a63b5b418665e79447cac66d.svg";
export { ForwardRef as ReactComponent };